import makeStyles from '@mui/styles/makeStyles';

const operationsHomePageStyles = makeStyles((theme) => ({
    paddingBottom2: {
        paddingBottom: theme.spacing(1)
    },
    columnStyle: {
        flexGrow: 1,
        width: '50%',
        minWidth: '300px',
        maxWidth: '600px'
    },
    container: {
        padding: theme.spacing(0, 2.3)
    }
}));

export default operationsHomePageStyles;
